import { RouterOutput } from "@mindlercare/mindlerapi-client";
import type {
  CreateDescriptionMessages,
  PsychologistDescriptions,
} from "./type";

export const filterFetchedDescription = (
  fetchedDescriptions: PsychologistDescriptions,
  countryId: number,
): CreateDescriptionMessages =>
  fetchedDescriptions?.filter(
    (description) => description.countryLanguage.countryId === countryId,
  );

type GetDescriptionsProps = {
  descriptions: CreateDescriptionMessages;
  activeMarket: RouterOutput["application"]["markets"][number];
};
export const getDescriptions = ({
  descriptions,
  activeMarket,
}: GetDescriptionsProps): CreateDescriptionMessages => {
  if (descriptions?.length) {
    return descriptions;
  }
  // create default description
  return activeMarket.languages.map((language) => ({
    countryLanguage: {
      countryId: activeMarket.countryId,
      languageId: language.languageId,
    },
    description: "",
  }));
};

export const getUpdatedDescriptions = (
  previousDescriptions: CreateDescriptionMessages,
  countryId: number,
  languageId: number,
  newValue: string,
): CreateDescriptionMessages =>
  previousDescriptions.map((description) =>
    description.countryLanguage.countryId === countryId &&
    description.countryLanguage.languageId === languageId
      ? { ...description, description: newValue }
      : description,
  );
